import { call } from 'redux-saga/effects';
import { CountersResource } from '../../core/resources/counters.resource';
import { countersSerializer } from '../../models/counters/counters.serializer';
import { IApiCounters } from '../../models/counters/counters.types';

export function* getCounters() {
  const response: IApiCounters = yield call(CountersResource.getCounters);

  return countersSerializer(response);
}
